export const PROTEIN_BREAD_BADGE_SRC = "/ProteinTag.png";
export const PROTEIN_BREAD_FILTER_ICON_SRC = "/ProteinIcon.png";
export const PROTEIN_BREAD_FILTER_TAG_ID = "protein-bread-choice";
export const PROTEIN_BREAD_FILTER_TAG = {
  id: PROTEIN_BREAD_FILTER_TAG_ID,
  name: "Protein Upgrade",
  description: "",
  categoryImage: PROTEIN_BREAD_FILTER_ICON_SRC,
  products: [],
  isTag: true,
};

function textIncludes(value, searchTerm) {
  return String(value || "").toLowerCase().includes(searchTerm);
}

function optionIsProteinBread(option) {
  return textIncludes(option?.title, "protein bread") || textIncludes(option?.name, "protein bread");
}

function groupIsBreadChoice(group) {
  const groupText = [
    group?.optionSetName,
    group?.optionSetDescription,
    group?.name,
    group?.title,
  ].join(" ");

  return textIncludes(groupText, "bread");
}

function groupHasProteinBread(group) {
  if (!group || !Array.isArray(group.options)) {
    return false;
  }

  const isBreadChoice = groupIsBreadChoice(group);

  return group.options.some((option) => (
    (isBreadChoice && optionIsProteinBread(option)) ||
    optionHasProteinBreadChoice(option)
  ));
}

function optionHasProteinBreadChoice(option) {
  if (optionIsProteinBread(option)) {
    return true;
  }

  return Array.isArray(option?.optionSets) && option.optionSets.some(groupHasProteinBread);
}

export function productHasProteinBreadChoice(product) {
  return Array.isArray(product?.variations) && product.variations.some(groupHasProteinBread);
}
